module.exports = __webpack_public_path__ + "7076da343ae7f88aac30f6debe167fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-660.jpg
// module id = 539
// module chunks = 0